import { render, staticRenderFns } from "./AssignAdminModal.vue?vue&type=template&id=4f11c31c&scoped=true&"
import script from "./AssignAdminModal.vue?vue&type=script&lang=js&"
export * from "./AssignAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignAdminModal.vue?vue&type=style&index=0&id=4f11c31c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11c31c",
  null
  
)

export default component.exports